import { Component } from '@angular/core'

@Component({
  selector: 'ai-reconciler-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class AiReconcilerDashboardComponent {}
